import { AutopilotTaskDto, TaskStepDto } from '@urbanx/agx.activities.client';
import { Range } from '@urbanx/agx.ui-components2';

export interface StepsCompletionResult {
  allStepsCompleted: boolean;
  latestCompletedDate?: Date;
}

export const getTaskStepDueDate = (step: TaskStepDto): string | undefined => {
  const stepWithDueDate = step as TaskStepDto & {
    dueDate?: Date | string;
    data?: TaskStepDto['data'] & { dueDate?: Date | string };
  };

  const rawDueDate = stepWithDueDate.dueDate ?? stepWithDueDate.data?.dueDate;
  if (!rawDueDate) return undefined;

  const date = rawDueDate instanceof Date ? rawDueDate : new Date(rawDueDate);
  if (Number.isNaN(date.getTime())) return undefined;

  return date.toISOString();
};

export const getStepCompletionPercentage = (steps: TaskStepDto[]): Range<0, 100> => {
  if (steps.length === 0) return 0;

  const completed = steps.filter((step) => step.isCompleted).length;
  return Math.round((completed / steps.length) * 100) as Range<0, 100>;
};

export const getStepsCompletionInfo = (tasks: AutopilotTaskDto[]): StepsCompletionResult => {
  const allSteps = tasks.flatMap((task) => task.taskSteps ?? []);

  const allStepsCompleted =
    allSteps.length > 0 && allSteps.every((step) => step.isCompleted === true);

  const latestCompletedDate = allSteps
    .filter((step) => step.isCompleted === true && step.completedUtc !== undefined)
    .reduce<Date | undefined>((latest, step) => {
      if (!step.completedUtc) return latest;

      const completedUtc = new Date(step.completedUtc);
      if (Number.isNaN(completedUtc.getTime())) return latest;
      if (!latest) return completedUtc;

      return completedUtc > latest ? completedUtc : latest;
    }, undefined);

  return { allStepsCompleted, latestCompletedDate };
};
